import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import image from './images/googleimg.png';
import logo from './images/rosai.jpg';
import './App.css';

const SignIn = () => {
  const navigate = useNavigate();

  const login = useGoogleLogin({
    onSuccess: async (response) => {
      try {
        const userInfoResponse = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: {
            'Authorization': `Bearer ${response.access_token}`
          }
        });

        const user = await userInfoResponse.json();
        const userEmail = user.email;
        sessionStorage.setItem('userEmail', user.email);

        // Create folder on the server
        const createFolderResponse = await fetch('https://www.d-rosa.ai/user_folder', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            path: '/var/www/myflaskapp/flask_static',
            folder_name: userEmail, // Use userEmail as the folder name
          }),
        });

        // Log the status to debug response
        console.log('Create folder response status:', createFolderResponse.status);
        const createFolderResult = await createFolderResponse.json();

        if (createFolderResponse.ok) {
          console.log(createFolderResult.message);
        } else {
          console.error('Error from server:', createFolderResult.error);
        }

        navigate('/main');
      } catch (error) {
        console.error('Error during login or folder creation:', error);
      }
    },
    onError: () => {
      console.log('Login Failed');
    },
  });

  return (
    <div id="image-container">
      <img id="myimage" src={logo} alt="img" width="80" height="100" />
      <div className="button-container">
        <h2 className="center-heading" style={{ fontSize: '80px' }}>Sign In</h2><br />
        <br /><br /><br />
        <button className="button" onClick={login}>
          <img src={image} className="app-img" width="200" height="50" alt="img" />
        </button>
 <br />
        <br />
        <br />
        <br />
        <br />
        <br />

      </div>
      <footer className="footer-section">
        <div className="container-4">
          <div className="nav-items"></div>
          <div className="text-6">&copy; 2022 HYDAX Pvt. Ltd. All rights reserved.</div>
        </div>
      </footer>
    </div>
  );
};

export default SignIn;
